<template>
  <v-container fluid fill-height>
    <v-row>
      <v-col cols="12">
        <v-row justify="center" align="center">
          <v-col cols="12" style="max-width: 500px">
            <v-card>
              <v-toolbar dark color="primary">
                <v-spacer></v-spacer>
                <img src="@/assets/placemint.png" width="150" />
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-form ref="form">
                <v-container>
                  <v-container py-1 px-3>
                    <v-row class="grey lighten-5 px-2">
                      <v-col cols="12">
                        <v-text-field
                          name="email"
                          label="Email"
                          id="email"
                          v-model="email"
                          type="email"
                          required
                          outlined
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-if="!forgotPass"
                          name="password"
                          label="Password"
                          id="password"
                          v-model="password"
                          type="password"
                          required
                          outlined
                          hide-details
                        ></v-text-field>
                      </v-col>

                      <v-col>
                        <v-btn
                          block
                          color="primary"
                          :loading="loading"
                          :disabled="loading"
                          @click="submit()"
                          >{{
                            forgotPass ? "Send Reset Link" : "Sign In"
                          }}</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                  <v-alert
                    v-if="error"
                    :value="true"
                    outlined
                    text
                    type="error"
                    class="text-center mt-2 mb-0"
                    border="left"
                    dense
                    >Authentication Failed</v-alert
                  >
                </v-container>
              </v-form>

              <v-divider></v-divider>

              <v-card-text>
                <v-list
                  class="text-xs-center text-sm-center text-md-center text-lg-center pa-0"
                >
                  <div class="pa-2" v-if="!forgotPass">
                    <a
                      style="text-decoration: underline"
                      @click="forgotPass = true"
                      class="routerLinkStyle"
                      >Forgot your password?</a
                    >
                  </div>
                  <div class="pa-2" v-if="forgotPass">
                    <a
                      style="text-decoration: underline"
                      @click="forgotPass = false"
                      class="routerLinkStyle"
                      >Sign in</a
                    >
                  </div>
                  <div>
                    New to Placemint?
                    <router-link
                      :to="{ path: '/register' }"
                      class="routerLinkStyle"
                      >Create an account</router-link
                    >
                  </div>
                </v-list>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      email: "",
      password: "",
      forgotPass: false,
    };
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
      alert: (state) => state.alert,
    }),
    loading() {
      return this.account.loading;
    },
    error() {
      return this.account.error;
    },
  },
  methods: {
    ...mapActions("account", ["login", "forgotPassword", "clearError"]),
    submit() {
      if (this.forgotPass) {
        if (this.email) {
          this.forgotPassword(this.email);
        }
      } else {
        const { email, password } = this;
        if (email && password) {
          this.login({ email, password });
        }
      }
    },
  },
  mounted() {
    this.clearError();
  },
};
</script>
